<template>
     <div>


        <div class="loadingModal" v-if="isLoading">
            <div class="loader" ></div>
        </div>

        <div class="ProductsModal" v-if="ProductsModal">
            <div class="productsBox">
                <div class="header">
                    <i class="material-icons">add</i>
                    <span>הוספת מוצר להזמנה</span>
                    <button @click="closeModal"><i class="material-icons">close</i></button>
                </div>
                <div class="section">
                    <div class="collection">
                        <div class="category" @click="loadBigCakes()">
                            <span>עוגות מרובעות</span>
                        </div>
                        <div class="category" @click="loadCircleCakes()">
                            <span>עוגות עגולות</span>
                        </div>
                        <div class="category" @click="loadBiscuit()">
                            <span>עוגיות</span>
                        </div>
                        <div class="category" @click="loadPasim()">
                            <span>פסים</span>
                        </div>
                        <div class="category" @click="loadKofsaot()">
                            <span>קופסאות</span>
                        </div>
                        <div class="category" @click="loadMagashim()"><span>מגשים</span></div>
                        <div class="category" @click="loadOneUse()"><span>חד פעמי</span></div>
                        <div class="category" @click="loadDrinks()"><span>שתיה</span></div>
                        <div class="category" @click="loadHatifim()"><span>חטיפים</span></div>
                        <div class="category" @click="loadShmareem()"> <span>שמרים</span> </div>

                    
                    </div>
                    <b>{{ selectedCategory }}</b>
                    <div class="collection">
                        <div class="product" v-for="item in filteredProducts"  @click="pushToCart(item)">
                            <span class="productName">{{item.Data.Name}}</span>
                            <span class="productPrice">₪{{item.Data.Price}}</span>
                            <span class="productQuantity"> {{item.Data.Quantity}} במלאי</span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    <div class="selectedOrderContainer"  >
        
        <div class="btn-collection">
            <div class="back-field">
                <button class="back-btn" @click="backToOrders()"> 
                    <span class="material-icons">arrow_forward</span>
                </button>
            </div>
            <div class="left-field">
                <select @change="updatePayment()" :class="[orderOBJ.paidStatus == 'לא שולם' ? 'notPaidStatus' : '', orderOBJ.paidStatus == 'שולם' ? 'paidStatus' : ''] " v-model="orderOBJ.paidStatus" >
                    <option value="שולם">שולם</option>
                    <option value="לא שולם">לא שולם</option>
                </select>
                <button class="back-btn" @click="pushOrderToTrash()" v-if="$root.loggedUser.Type == 'Admin'"> 
                    <span class="material-icons">delete</span><p>העבר לאשפה</p>
                </button>
                
            </div>
        </div>
        <div class="recipetContainer">
            <div class="recipet">
                <span class="ordernumber font-noto">
                    הזמנה מס" #{{ orderOBJ.orderNumber }}
                </span>
                <span class="createdDate font-noto" >
                {{ orderOBJ.createdDate }}
                </span>
            </div>
            <div class="customerInfo">
                <div class="contactInfo">
                    <div class="contactHeader">
                        <p class="font-noto clientInfo">
                            פרטי לקוח
                        </p>
                        <i class="material-icons icon" @click="editInfoFun()"> edit</i>
                    </div>
                    
                    <div class="contactFields">
                    <div class="contactName">
                        <label>שם מלא</label>
                        <span class="nameField" v-if="!editInfo">{{ orderOBJ.fullname }}</span>
                        <input class="editField" type="text" v-if="editInfo" v-model="orderOBJ.fullname" />
                    </div>
                    <div class="contactName">
                        <label>מספר טלפון</label>
                        <img src="../../src/assets/whatsapp.png" class="whatsappIcon" @click="whatsappMessage()">
                        <span class="nameField" v-if="!editInfo">{{ orderOBJ.phoneNumber }}</span>
                        
                        <input class="editField" type="tel" v-if="editInfo" v-model="orderOBJ.phoneNumber" />
                    </div>
                    <div class="saveBtn" v-if="editInfo">
                        <button @click="updateOrderData()">שמור שינויים</button>
                    </div>
                    </div>
                </div>
                <div class="contactInfo">
                    <div class="contactHeader">
                        <p class="font-noto clientInfo">
                            תאריך אספקה
                        </p>
                        <i class="material-icons icon" @click="editDatesFun()"> edit</i>
                    </div>
                    
                    <div class="contactFields">
                    <div class="orderInfo">
                        <label>יום אספקה</label>
                        <span class="nameField" v-if="!editDates">{{ orderOBJ.selectedDateReadable }}</span>
                        <!-- التاريخ -->
                    <div class="edit-section" v-if="editDates">
                    <label>בחר תאריך חדש</label>
                    <Calendar @date-selected="updateDate" />
                    </div>
                    </div>
                    

                    <!-- الساعة -->
                    <!-- <div class="edit-section" v-if="editDates">
                    <label>בחר שעה חדשה</label>
                    <select v-model="orderOBJ.timeOrder">
                        <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
                    </select>
                    </div> -->


                    <div class="orderInfo">
                        <label>שעת אספקה</label>
                        <span v-if="!editDates" class="nameField">{{ orderOBJ.timeOrder }}</span>
                        <input class="editField" type="tel" v-if="editDates" v-model="orderOBJ.timeOrder" />
                    </div>
                    <div class="saveBtn" v-if="editDates">
                        <button @click="updateOrderData()">שמור שינויים</button>
                    </div>
                    </div>
                </div>
                <div class="orderCart">
                    <div class="orderCartHeader">
                        <div class="orderCartIconBox">
                            <i class="material-icons">shopping_cart</i>
                            <span class="orderCartText">פרטי הזמנה</span>
                        </div>
                        <div class="orderCartLeft">
                            <div class="plus"><button><i class="material-icons" @click="addToCart">add</i></button></div>
                            <div class="pen"><button @click="editCart"><i class="material-icons">edit</i></button></div>
                        </div>
                    </div>
                    
                    <div class="cartList">
                        <div class="cartItem" v-for="(item,index) in orderOBJ.cart">
                            <button v-if="editCartItems" @click="deleteItemFromCart(item,index)"><i class="material-icons">delete</i></button>
                            <span class="name">x{{ item.selectedCount }} | {{ item.Data.Name }} </span>
                            <span class="price">₪{{ item.Data.Price * item.selectedCount}}</span>
                        </div>
                    </div>


                    <div class="orderNote">
                        <div class="note" >
                            <pre v-if="!editCartItems">{{ orderOBJ.note }}</pre>
                            <input type="text" v-model="orderOBJ.note" v-if="editCartItems" >
                            <button @click="saveNote()" v-if="editCartItems">שמור שינויים</button>
                        </div>
                    </div>


                    <div class="orderCartFooter">
                        <div class="line">
                            <span class="rightText">סכום ההזמנה</span>
                            <span class="leftText">₪{{ orderOBJ.totalOrderPrice }}</span>
                        </div>
                        <div class="line">
                            <span class="rightText">הנחה</span>
                            <span class="leftText">₪{{ orderOBJ.discount }}</span>
                        </div>
                        <div class="line">
                            <span class="rightText">סה"כ לתשלום</span>
                            <span class="leftText">₪{{ orderOBJ.totalOrderPrice - orderOBJ.discount }}</span>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <div class="media-status-priceBox">
            <div class="statusBox">
                <div class="statusHeader">
                    <i class="material-icons icon">incomplete_circle</i>
                    <p class="font-noto">
                        סטטוס ההזמנה
                    </p>
                    <span class="statusBadge font-noto">
                        {{ orderOBJ.status }}
                    </span>
                </div>
                <div class="statusField">
                    <label for="" class="font-noto">שינוי סטטוס ההזמנה</label>
                    <select name="" id="" v-model="orderOBJ.status">
                        <option value="" selected>בחר סטטוס להזמנה</option>
                        <option value="מוכנה">מוכנה</option>
                        <option value="שלב הכנה">שלב הכנה</option>
                        <option value="בוטלה">בוטלה</option>
                        <option value="התקבלה">התקבלה</option>
                        <option value="נמסרה">נמסרה</option>
                    </select>
                </div>
                <div class="changeBtn">
                    <button class="font-noto" @click="updateStatus()">שינוי</button>
                </div>
            </div>
            <div class="statusBox">
                <div class="statusHeader">
                    <i class="material-icons icon">photo_camera</i>
                    <p class="font-noto">
                        הוספת תמונות להזמנה
                    </p> 
                </div>
                <div class="statusField">
                    <!-- <input type="file"  @change="uploadImage" accept="image/*" > -->
                    <input type="file" @change="handleFiles" multiple />
                    <div v-if="this.progress > 0">
                    <progress :value="progress" max="100" style="width: 100%;"></progress>
                    <p>{{ this.progress }}%</p>
                    </div>

                    <!-- {{ this.progress }} -->
                </div>
            </div>
            <div class="statusBox">
                <div class="statusHeader">
                    <i class="material-icons icon">photo_camera</i>
                    <p class="font-noto">
                        תמונות
                    </p>            
                </div>
                <div v-for="(img,index) in orderOBJ.orderImg" :key="'img'+index" style="display:block;width: 100%;margin-top: 10px;">
                    <i class="material-icons icon" @click="deleteImage(img,index)">delete</i>
                    <img :src="img" alt="" width="100%" >   
                </div>



                
            </div>
        </div>
        


    </div>
    </div>
</template>
<script>
  import { db } from '../firebase';
  import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import Calendar from "@/components/Calendar.vue"; // عدّل المسار حسب مكان الملف

  export default {
    name: 'SelectedOrderBeta',
    components: {
    Calendar
  },
    data () {
      return {
        editOrder: true,
        id:this.$route.params.id,
        selectedorderID: this.$route.params.id,
        orderOBJ:'',
        newImage:'',
        deleted:true,
        editInfo:false,
        editDates:false,
        editCartItems:false,
        isLoading:true,
        ProductsModal:false,
        Products:[],
        selectedCategory:'',
        txtSearch:'',
        productObj:"",
        progress: '',
        files: [], // لتخزين الملفات المختارة
        uploadedImages: [], // لتخزين روابط الصور بعد رفعها
        hours: []

        
      }
    },
    created (){
        let vm = this;
        console.log(vm.selectedorderID);
        vm.loadSingleOrder();
        this.generateHours();
        console.log("URL :", window.location.href);
    },
    computed: {
      filteredProducts() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let Products = [];
          for (let i = 0; i < vm.Products.length; i++) {
            let t = vm.Products[i];
            let found = false;
            if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (found) {
                Products.push(t);
            }
          }
          return Products;
        } else {
          return vm.Products;
        }
      }
    },
    methods : {
        updateDate(newDate) {
    this.orderOBJ.selectedDateReadable = newDate.readable;
    // optional: this.orderOBJ.dateOrder = this.extractISODate(newDate.readable);
  },
  generateHours() {
    let startHour = 9.5; // 9:30
    let endHour = 21.5;
    let result = [];

    for (let h = startHour; h <= endHour; h += 0.5) {
      const hour = Math.floor(h);
      const minutes = h % 1 === 0 ? "00" : "30";
      result.push(`${hour.toString().padStart(2, '0')}:${minutes}`);
    }

    this.hours = result;
  },
  saveOrderUpdates() {
    db.collection("orders").doc(this.selectedorderID).update({
      selectedDateReadable: this.orderOBJ.selectedDateReadable,
      timeOrder: this.orderOBJ.timeOrder
    }).then(() => {
      alert("העדכון בוצע בהצלחה");
    }).catch((err) => {
      console.error("❌ Error updating order:", err);
    });
  },
        handleFiles(event) {
      // تحويل الملفات المختارة إلى مصفوفة
      this.files = Array.from(event.target.files);

      // رفع الملفات إلى Firebase
      this.uploadFiles();
    },
    uploadFiles() {
  const storageRef = firebase.storage().ref(); // مرجع Firebase Storage

  this.files.forEach((file) => {
    // توليد اسم فريد للملف لتجنب التكرار عند رفع صور من الهاتف
    const uniqueFileName = `${this.selectedorderID}_${Date.now()}_${file.name}`;
    const fileRef = storageRef.child(`orders/${uniqueFileName}`); // تحديد مسار التخزين باستخدام الاسم الفريد
    const uploadTask = fileRef.put(file); // إنشاء مهمة الرفع

    // مراقبة تقدم عملية الرفع
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // حساب نسبة التقدم للملف الحالي
        const progressForFile = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log(`Progress for ${uniqueFileName}: ${progressForFile}%`);
        // يمكنك هنا استخدام متغير منفصل لكل ملف أو تجميع النسب حسب الحاجة
        this.progress = progressForFile; // أو تحديث واجهة المستخدم بالطريقة المناسبة
      },
      (error) => {
        // معالجة الأخطاء
        console.error("خطأ أثناء رفع الملف:", error);
      },
      async () => {
        // عند اكتمال عملية الرفع، الحصول على رابط التحميل
        try {
          const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();

          // تحديث البيانات في Firestore بإضافة الرابط إلى مصفوفة الصور الخاصة بالطلب
          await db.collection("orders")
            .doc(this.selectedorderID)
            .update({
              orderImg: firebase.firestore.FieldValue.arrayUnion(downloadURL),
            });

          console.log("تم تحديث الوثيقة وإضافة الرابط بنجاح");
          this.uploadedImages.push(downloadURL); // حفظ الرابط محليًا
          this.loadSingleOrder();
        } catch (error) {
          console.error("خطأ أثناء تحديث الوثيقة:", error);
        }
      }
    );
  });
}
,

        uploadImage(file){
          // Create the file metadata
          let vm = this;
          let e = file.target.files[0]
          
          const storageRef = firebase.storage().ref();

                // Upload file and metadata to the object 'images/mountains.jpg'
                var uploadTask = storageRef.child('orders/' + e.name).put(e);

                // Listen for state changes, errors, and completion of the upload.
                uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                    (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    vm.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + vm.progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused');
                        break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                        break;
                    }
                    }, 
                    (error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                        case 'storage/canceled':
                        // User canceled the upload
                        break;

                        // ...

                        case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    }
                    }, 
                    () => {
                        
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                        vm.orderOBJ.orderImg.push(downloadURL);
                        db.collection("orders").doc(vm.selectedorderID).update({orderImg : vm.orderOBJ.orderImg});
                        console.log('File available at', downloadURL);
                    });
                    }
                );

        },
        backToOrders(){
          let vm = this;
          console.log("backToOrders()");
          vm.$router.push("/ordersBeta");
        },
        deleteOrder(){
          let vm = this;
          console.log("Order Id is : ", vm.selectedorderID)
          let answer = confirm("האם אתה בטוח למחוק ההזמנה?" );
          
          if (answer){
            db.collection("orders").doc(vm.selectedorderID).delete().then(() => {
                console.log("Document successfully deleted!");
                vm.$router.push("/Home");
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });

          }
        },
        deleteImage(img,index){
            let vm = this;
            console.log("Order Id is : ", vm.selectedorderID)
            let answer = confirm("האם אתה בטוח למחוק התמונה?" );
            
            if (answer){
                vm.orderOBJ.orderImg.splice(index,1);
                db.collection("orders").doc(vm.selectedorderID).update({orderImg:vm.orderOBJ.orderImg});
          }
        },
        updateStatus(){
            let vm = this;
            let newStatus = vm.orderOBJ.status;
            db.collection("orders").doc(vm.selectedorderID).get()
            .then((order) =>{
                let orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                db.collection("orders").doc(vm.selectedorderID).update({status:vm.orderOBJ.status});
                console.log("New Status is :" + newStatus) ;
                alert("סטטוס ההזמנה עודכן בהצלחה")
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        saveNote(){
            let vm = this;
            let newNote = vm.orderOBJ.note;
            db.collection("orders").doc(vm.selectedorderID).get()
            .then((order) =>{
                let orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.note = newNote;
                db.collection("orders").doc(vm.selectedorderID).update({note:vm.orderOBJ.note});
                console.log("New Status is :" + newNote) ;
                alert("הערת ההזמנה עודכן בהצלחה");
                vm.editCartItems = false;
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        whatsappMessage(){
            let vm = this;
            // window.open("https://wa.me/85261234567" );
            window.open("https://api.whatsapp.com/send?phone=972"+ vm.orderOBJ.phoneNumber );
            
        },
        updatePayment(){
            let vm = this;
            let newPayment = vm.orderOBJ.paidStatus;
            db.collection("orders").doc(vm.selectedorderID).get()
            .then((order) =>{
                let orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.paidStatus = newPayment;
                db.collection("orders").doc(vm.selectedorderID).update({paidStatus: vm.orderOBJ.paidStatus});
                console.log("New Status is :" + newPayment) ;
                alert("סטטוס הגבייה עודכן בהצלחה")
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
      updateOrderData() {
  let vm = this;

  // استخرج البيانات المطلوبة
  let updatedData = {
    fullname: vm.orderOBJ.fullname,
    phoneNumber: vm.orderOBJ.phoneNumber,
    timeOrder: vm.orderOBJ.timeOrder,
    selectedDateReadable: vm.orderOBJ.selectedDateReadable,
  };

  // إزالة أي قيم undefined (لو ناقص إشي)
  Object.keys(updatedData).forEach(key => {
    if (updatedData[key] === undefined) {
      delete updatedData[key];
    }
  });

  // تحديث الطلب
  db.collection("orders").doc(vm.selectedorderID).update(updatedData)
    .then(() => {
      console.log("Order Successfully Updated!");
      vm.editInfo = false;
      vm.editDates = false;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
},
        loadSingleOrder(){
            let vm = this;
            db.collection("orders").doc(vm.selectedorderID).get()
            .then((order) =>{
                vm.isLoading = false;
                let orderData = order.data();
                let fullname = orderData.fullname;
                let orderNumber = orderData.orderNumber;
                let dayOrder = orderData.dayOrder;
                let dateOrder = orderData.dateOrder;
                let createdDate = orderData.createdDate;
                let phoneNumber = orderData.phoneNumber;
                let status = orderData.status;
                let timeOrder = orderData.timeOrder;
                let totalOrderPrice = orderData.totalOrderPrice;
                let orderImg = orderData.orderImg;
                let cart = orderData.Cart;
                let paidStatus = orderData.paidStatus;
                let discount = orderData.discount;
                let note = orderData.note;
                let selectedDateReadable = orderData.selectedDateReadable;

                // console.log(fullname);
                console.log(orderData);
                vm.orderOBJ = {
                    fullname : orderData.fullname,
                    orderNumber : orderData.orderNumber,
                    dayOrder : orderData.dayOrder,
                    dateOrder : orderData.dateOrder,
                    createdDate : orderData.createdDate,
                    phoneNumber : orderData.phoneNumber,
                    status : orderData.status,
                    timeOrder : orderData.timeOrder,
                    totalOrderPrice : orderData.totalOrderPrice,
                    orderImg : orderData.orderImg,
                    cart : orderData.cart,
                    paidStatus : orderData.paidStatus,
                    discount : orderData.discount,
                    selectedDateReadable : orderData.selectedDateReadable,
                    note : orderData.note
                }
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        pushOrderToTrash(){
            let vm = this;
            let answer = confirm("האם אתה בטוח להעביר את ההזמנה לפח?")
            if(answer){
                db.collection("orders").doc(vm.selectedorderID).update({
                status: "נמחקה"  
            });
            alert("ההמזנה הועברה לאשפה!")
            }
            
        },
        editInfoFun(){
            let vm = this;
            // vm.editInfo = true;
            if (vm.editInfo) {
            vm.editInfo = false;
            } else {
                vm.editInfo = true;
            }
        },
        editDatesFun(){
            let vm = this;
            if (vm.editDates) {
            vm.editDates = false;
            } else {
                vm.editDates = true;
            }
        },
        editCart(){
            let vm = this;
            if (vm.editCartItems) {
            vm.editCartItems = false;
            } else {
                vm.editCartItems = true;
            }
        },
        addToCart(){
            let vm = this;
            if (vm.ProductsModal) {
            vm.ProductsModal = false;
            } else {
                vm.ProductsModal = true;
            }
        },
        closeModal(){
            let vm = this;
            if (vm.ProductsModal) {
            vm.ProductsModal = false;
            } 
        },
        pushToCart(item){
            let vm = this;
            let selectedCount = 1;
                const existingItem = vm.orderOBJ.cart.find(cartItem => cartItem.ID === item.ID);
                vm.productObj = item;
                    console.log(vm.productObj);
                if (existingItem) {
                    existingItem.selectedCount++;
                    let newQuantity = item.Data.Quantity - existingItem.selectedCount;
                        db.collection("Products").doc(item.ID).get()
                        .then((order) =>{
                            let orderData = order.data();
                            orderData.Quantity = newQuantity;
                            db.collection("Products").doc(item.ID).update(orderData);
                            console.log("New Amoumt is :" + newQuantity) ;
                            
                        })
                        .catch((error) =>{
                            console.log("Error :" , error);
                        })
                } else {
                    vm.orderOBJ.cart.push({ ...item, selectedCount: 1 });
                    let newQuantity = item.Data.Quantity - 1;
                        db.collection("Products").doc(item.ID).get()
                        .then((order) =>{
                            let orderData = order.data();
                            orderData.Quantity = newQuantity;
                            db.collection("Products").doc(item.ID).update(orderData);
                            console.log("New Amoumt is :" + newQuantity) ;
                            
                        })
                        .catch((error) =>{
                            console.log("Error :" , error);
                        })
                }
                vm.orderOBJ.totalOrderPrice += item.Data.Price;
                console.log(vm.orderOBJ.cart);
                db.collection("orders").doc(vm.selectedorderID).update({
                    cart: vm.orderOBJ.cart,
                    totalOrderPrice: vm.orderOBJ.totalOrderPrice

                });
        },
        deleteItemFromCart(item,index){
            let vm = this;
            let answer = confirm("האם אתה בטוח למחוק את המוצר הזו?")
            console.log("Delete Started!");
            console.log("Item : ", item);
            if(answer){
                vm.orderOBJ.totalOrderPrice = vm.orderOBJ.totalOrderPrice - item.Data.Price * item.selectedCount;
                vm.orderOBJ.cart.splice(index,1);
                db.collection("orders").doc(vm.selectedorderID).update({
                    cart: vm.orderOBJ.cart,
                    totalOrderPrice: vm.orderOBJ.totalOrderPrice
                });
            }

        },
        loadProducts(){
            let vm = this;
            vm.Products = [];
            db.collection("Products").where("category", "==", vm.selectedCategory).get().then((result)=>{
                for(let a = 0; a < result.size; a++){
                      let itemId = result.docs[a].id;
                      let item = result.docs[a].data();
                      // console.log(orderResult.size);
                      vm.Products.push({
                        ID : itemId,
                        Data : item
                        
                        });
              }
              vm.totalProducts = result.size;

            }).catch((error)=>{
                console.log("Error Loading Products", error)
            })
        },
        loadBigCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות מרובעות';
            vm.loadProducts();
        },
        loadCircleCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות עגולות';
            vm.loadProducts();
        },
        loadPasim(){
            let vm = this;
            vm.selectedCategory = 'פסים ושמרים';
            vm.loadProducts();
        },
        loadHatifim(){
            let vm = this;
            vm.selectedCategory = 'חטיפים';
            vm.loadProducts();
        },
        loadshtea(){
            let vm = this;
            vm.selectedCategory = 'שתיה';
            vm.loadProducts();
        },
        loadSpecialCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות להזנמות';
            vm.loadProducts();
        },
        loadShmareem(){
            let vm = this;
            vm.selectedCategory = 'שמרים';
            vm.loadProducts();
        },
        loadMagashim(){
            let vm = this;
            vm.selectedCategory = 'מגשים';
            vm.loadProducts();
        },
        loadOneUse(){
            let vm = this;
            vm.selectedCategory = 'חד פעמי';
            vm.loadProducts();
        },
        loadKofsaot(){
            let vm = this;
            vm.selectedCategory = 'קופסאות';
            vm.loadProducts();
        },

    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap');

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
body{
    background-color: #f9f9f9;
}
.font-noto{
    font-family: 'Noto Sans Hebrew';
    
}
.loadingModal{
    width: 100%;
    height: 100%;

    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: fixed;
    z-index: 11111;
    margin-right: -300px;
    margin-top: -70px;
    background-color: rgba(0,0,0,0.2);
}
.loader{
    margin:  auto;
    border: 10px solid #EAF0F6;
    border-radius: 50%;
    border-top: 10px solid #00414d;
    width: 100px;
    height: 100px;
    animation: spinner 1s linear infinite;
    z-index: 100000;
}
.ProductsModal{
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.2);
    z-index: 99999;
    margin-right: -300px;
    margin-top: -70px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.productsBox{
    width: 50%;
    min-height: 400px;
    border-radius: 5px;
    background-color: #fff;
}
.productsBox .header{
    padding: 1rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f4f5f8;
    position: relative;
}
.productsBox .header i{
    font-size: 18px;
    color: #141c29;
}
.productsBox .header span{
    margin-right: 10px;
    font-size: 14px;
    color: #141c29;
    font-family: 'Noto Sans Hebrew';
}
.productsBox .header button{
    position: absolute;
    left: 0;
    padding: 5px 10px;
    border: 0;
    background-color: transparent;

}
.section{
    padding: 1rem;
    display: flex;
    flex-direction: column;
}
.collection{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: scroll;
    margin: 10px 0;
}
.category{
    margin: 5px;
    height: 120px;
    background: transparent;
    border: 2px solid #00414d;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.category span{
    text-align: center;
    font-weight: 400;
    color: #000;
    font-size: 18px;
    width: 130px;
    padding: 10px;
    color: #000;
    font-family: 'Noto Sans Hebrew';
}
.product{
    min-width: 170px;
    min-height: 150px;
    background: transparent;
    border: 2px solid #00414d;
    border-radius: 2px;
    position: relative;
    text-align: center;
    padding: 1rem;
    margin: 5px;
    font-family:'Noto Sans Hebrew';
}
.note{
    margin: 5px 0;
    padding: 0;
    position: relative;
}
.note pre{
    background-color:#ffe082 ;
    padding: 5px 10px;
    color: #000;
    display: block;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-size: 14px;
}
.note button{
    position: absolute;
    left: 1rem;
    top: 0;
}
.productName{
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.productPrice{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    font-size: 20px;
    font-weight: 600;
}
.productQuantity{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 18px;
    font-weight: 400;
    color:#666;
}
@keyframes spinner {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.selectedOrderContainer{
    width: 100%;
    /* background-color: yellow; */
    padding: 1rem;
    height: 100%;

}
.btn-collection{
    width: 100%;
    display: flex;
    align-items: center;
    /* border: 1px solid #ccc; */
    padding: 1rem 0;
}
.back-field{
    width: 20%;
}
.back-btn, .print-btn, .paidStatus, .notPaidStatus{
    padding: 5px 15px;
    height: 40px;
    background-color: #f4f5f8;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    border-radius: 8px;
    margin-left: 10px;
    font-size: 14px;
    max-width:140px;
}
.whatsappIcon{
    width: 25px;
    position: absolute;
    left: 30px;
    bottom: 20px;
}
.print-btn{
    margin-left: 10px;

}
.back-btn{
    margin-left:0;
}
.back-btn span, .print-btn span{
    font-size: 16px;
}
.back-btn p{
    font-size: 14px;
    font-family: 'Noto Sans Hebrew';
    color: #1c1c1c;
}
.print-btn p{
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;
} 
.left-field{
    width: 80%;
    display: flex;
    justify-content: left;
}
.paidStatus{
    background-color: #dbeada;
    color: #298f33;
    padding: 5px 10px;
    border-radius: 8px;
    display: inline-block;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-size: 14px;
    outline:none;
}
.notPaidStatus{
    background-color: #fbe7e2;
    color: #dc1213;
    padding: 5px 10px;
    border-radius: 8px;
    display: inline-block;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    outline:none;
}
.icon{
    font-size: 16px;
    margin-left: 10px;
}
.recipetContainer{
    width: 70%;
    min-height: 500px;
    float: right;
}
.recipet{
    width: 100%;
    height: 65px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    position: relative;
}
.ordernumber{
    font-size: 16px;
    font-weight: 600;

}
.createdDate{
    position: absolute;
    left: 1rem;
    font-size: 14px;
    color: #666;
}
.media-status-priceBox{
    width: 29%;
    min-height: 165px;
    float: left;
}
/* .priceBox{
    width: 100%;
    height: 65px;
    background-color: #fff;
    padding: 0 1rem;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    display: flex;
    align-items: center;
    position: relative;
} */
.priceBox p, .statusHeader p{
    font-weight: 600;
    font-size: 14px;
}
.priceBox span, .statusHeader span{
    text-align: left;
    position: absolute;
    left: 1rem;
    background: #f5f5f5;
    padding: 5px 15px;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
}
.statusBox{
    min-height: 120px;
    margin-bottom: 10px;
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
    border: 1px solid #e0e0e0;
    position: relative;
    padding: 0 1rem 1rem;
}
.statusBox .statusHeader{
    border-bottom:1px solid #f5f5f5;
    display: flex;
    align-items: center;
    padding: 1rem 0;
}
.statusField{
    padding: 1rem 0;
}
.statusField label{
    margin-bottom: 5px;
    font-size: 13px;
    color: #666;
}
.statusField select{
    width: 100%;
    height: 40px;
    border-radius: 8px;
    padding: 0 10px ; 
    color: #666;
    border: 1px solid #e0e0e0;
    font-size: 13px;
    outline: none;
}
.statusField input{
    width: 100%;
    font-size: 14px;
    border: 1px solid #e0e0e0;
    padding: 0.5rem;
}
.changeBtn{
    position: relative;
}
.changeBtn button{
    background-color: #1c1c1c;
    color: #fff;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    border: 0;
    width: 100px;
    height: 40px;
}
.customerInfo{
    width: 100%;
    min-height: 445px;
    background-color: transparent;
    padding: 0;
    border-radius: 8px;
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
.contactInfo{
    width: 100%;
    min-height: 100px;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    border: 1px solid #e0e0e0;
    margin-bottom: 10px;
    overflow: hidden;
}
.contactHeader{
    border-bottom: 1px solid #ccc;
    position: relative;
    display: flex;
    align-items: center;
    padding: 1rem;
    background-color: #eef9fb;

}
.clientInfo{
    font-weight: bold;
    font-size: 14px;
}
.contactHeader> i{
    font-size: 21px;
    position: absolute;
    left: 0;

}
.contactFields{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    flex-wrap: wrap;
}
.contactName{
    margin-top: 0.5rem;
    width: calc(100% / 2 - 5px);
 }
 .orderInfo{
    margin-top: 0.5rem;
    width: calc(100% / 3 - 5px);
 }
 .contactName label, .orderInfo label{
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #666;
    font-family: 'Noto Sans Arabic', 'Noto Sans Hebrew';
 }
 .contactName .nameField, .orderInfo .nameField, .editField{
    padding: 5px 8px;
    background-color: #ffffff;
    width: 100%;
    display: block;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    font-family: 'Noto Sans Arabic', 'Noto Sans Hebrew';
    border: 1px solid #e0e0e0;
    -webkit-appearance:none;
 }
 .editField{
    border: 2px solid #cab36b;
 }
 .saveBtn{
    margin: 10px 0;
 }
 .saveBtn button{
    width: 100%;
    background-color: #1c1c1c;
    color: #f4f5f8;
    border: 0;
    padding: 10px 15px;
    border-radius: 8px;
    font-family: 'Noto Sans Hebrew';
    font-size: 14px;
    letter-spacing: 0.5px;
 }
 .orderCart{
    width: 100%;
    min-height: 350px;
    background-color: #fff;
    float: right;
    padding: 0 1rem;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    overflow: hidden;
    position: relative;
 }
 .orderCartHeader{
    width: 100%;
    padding: 1rem 0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: space-between;
 }
 .orderCartIconBox {
    /* border: 1px solid #e0e0e0; */
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
 }
 .orderCartIconBox i {
    font-size: 18px;
    color: #1c1c1c;
 }
 .orderCartLeft{
    display: flex;
    align-items: center;
 }
 .orderCartLeft > .plus{
    margin: 0 10px;
 } 
 .orderCartLeft .plus button,
 .orderCartLeft .pen button{
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    background-color: #f4f5f8;
    border-radius: 5px;
 } 
 .orderCartLeft .plus button{
    background-color: #141c29;
    color: #f4f5f8;
 }
 .orderCartText{
    font-size: 14px;
    font-family: 'Noto Sans Hebrew';
    font-weight: 600;
    color: #1c1c1c;
    margin-right: 10px;
 }
 .cartItem{
    padding: 1rem ;
    background: #f9f9f9;
    margin: 5px 0;
    position: relative;
    display: flex;
    align-items: center;
 }
 .cartItem button {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    background-color: #dc1213;
    color: #000;
    border-radius: 5px;
    margin-left: 10px;
 }
 .cartItem button i{
    color: #fff;
    font-size: 18px;
 }
.cartItem .name{
    color: #1c1c1c;
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: 500;
}   
.cartItem .price{
    color: #000;
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    left: 1rem;
}
.orderCartFooter{
    width: 100%;
    min-height: 80px;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #343a40;
}
.orderCartFooter .line{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #e0e0e0;
}
@media screen and (max-width: 1180px)
{

    .priceBox{
        margin-top:  10px;
    }
    .loadingModal{
        margin-right: 0;
    }
    .ProductsModal{
        margin-right:0;
    }
    .productsBox{
        width:95%;
    } 
}
@media screen and (max-width: 500px){
    .recipetContainer{
        width: 100%;
        min-height: auto;
    }
    .customerInfo{
        width: 100%;
        display: block;
        min-height: 100px;
    }
    .orderCart{
    width: 100%;
    margin-top: 10px;
    margin-right: 0;
    }
    .contactInfo{
        width: 100%;
    }
    .media-status-priceBox {
    width: 100%;
    min-height: 724px;

    }
    .priceBox{
        margin-top:  10px;
    }
    .loadingModal{
        margin-right: 0;
    }
    .ProductsModal{
        margin-right:0;
    }
    .productsBox{
        width:95%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/SelectedOrderBeta.vue